'use client';

import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '@lib/utils';

function Switch({
  className,
  label,
  disabled,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & { label?: string }) {
  return (
    <div
      className={cn(
        'text-xs flex gap-x-2.5 items-center',
        disabled ? 'cursor-not-allowed opacity-50' : '',
        className
      )}
    >
      <SwitchPrimitive.Root
        className={
          'peer data-[state=checked]:bg-blue data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-5 w-9 shrink-0 items-center rounded-full border-2 border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px]'
        }
        data-slot="switch"
        disabled={disabled}
        {...props}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            'bg-white pointer-events-none block size-4 rounded-full ring-0 shadow-lg transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0'
          )}
          data-slot="switch-thumb"
        />
      </SwitchPrimitive.Root>
      {label ? <p>{label}</p> : null}
    </div>
  );
}

export { Switch };
